var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgExclamationTriangle = function SvgExclamationTriangle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 20H4.39a1.4 1.4 0 0 1-1.2-2.09L10.8 4.69a1.39 1.39 0 0 1 2.39 0l7.61 13.22A1.4 1.4 0 0 1 19.6 20Zm-8-14.27L4.5 18.03c-.16.3.04.7.39.7h14.22c.36 0 .56-.39.39-.7l-7.11-12.3a.45.45 0 0 0-.78 0M11.3 9.5c0-1 1.4-1 1.4 0v4.29c0 1-1.4 1-1.4 0zm1.4 6.85c0 .37-.33.65-.7.65s-.7-.28-.7-.65.33-.65.7-.65.7.28.7.65"
  })));
};
export { SvgExclamationTriangle as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamationTriangle.f6703d8533c7c7ece892d91f8824653c.svg";